<div class="editor-container">
  <div>
    <attributes-editor
      (blurred)="doSaveDocument($event)"
      [dataSource]="editorDataSource"
      [mode]="personDetailsMode"
      [entityId]="personId"
      [isModal]="true"
    ></attributes-editor>
    <div>
      <button mat-raised-button color="primary" (click)="doSave()" *ngIf="!isDocument()">Save</button>
      <button mat-button type="button" (click)="onClose()">
        {{ isDocument() ? 'Close' : 'Cancel' }}
      </button>
    </div>
  </div>
</div>
